import { colors } from "@dotnet/telematics-design-system";

export const formNamestyleOverrides = {
  lineHeight: "40px",
  fontWeight: 600,
  letterSpacing: "0.25px",
  whiteSpace: "pre-line"
};

export const secondaryTextStyleOverrides = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  marginTop: "8px"
};

export const backgroundGridStyleOverrides = (bgImageDesktop: string) => {
  return {
    gridColumn: "6 / -1",
    backgroundImage: `url(${bgImageDesktop})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundColor: colors.blue100,

    "@media (max-width:1439px)": {
      gridColumn: "7 / -1"
    }
  };
};

export const loginFailedMessage =
  "The email address or password you entered is incorrect.";

export const endOfBetaVersionDate = "2025-04-11 14:00";
export const endOfReleasePreparation = "2025-04-28 23:59";

export const creditsReportMinDate = "2026-03-01 00:00";
